import { faFilePdf, faSpinner } from "@fortawesome/pro-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { IconButton } from "@scribenote/brian-design-system";

/**
 * The PDF export affordance for a single view: rasterises the rendered view to
 * a PDF. `onExport` and `exporting` come from `useViewPdfExport`, which also
 * owns the capture `ref`. Quiet ink on the document's masthead (the standard
 * ghost IconButton), not a raised chip: the sheet is the object, its controls
 * are annotations.
 */
export const ViewExportButton = ({
  viewId,
  onExport,
  exporting,
}: {
  viewId: string;
  onExport: () => void;
  exporting: boolean;
}) => (
  <IconButton
    onClick={onExport}
    disabled={exporting}
    aria-label="Export view as PDF"
    data-testid={`view-export-${viewId}`}
  >
    <FontAwesomeIcon
      icon={exporting ? faSpinner : faFilePdf}
      spin={exporting}
    />
  </IconButton>
);
